/**
 * cells/RefreshSuggestedCell.tsx
 *
 * Pill button that signals an EPC refresh is suggested.
 * Clicking opens the EpcRefreshSuggestionModal (trigger passed from parent).
 */
import { Warning } from "@phosphor-icons/react";
import { EPCData } from "shared/components/maintenance/hooks/useEnergyPerformanceData";

interface RefreshSuggestedCellProps {
  unit: EPCData;
  onOpenRefreshModal: () => void;
}

export function RefreshSuggestedCell({
  unit,
  onOpenRefreshModal,
}: RefreshSuggestedCellProps) {
  if (!unit.epcRefreshSuggested) {
    return <span className="text-neutral-secondary-mid text-xs">—</span>;
  }

  const isEnergetic = unit.epcRefreshReason === "ENERGETIC";
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onOpenRefreshModal();
      }}
      className={`inline-flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-xs font-semibold transition-all hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-1 ${
        isEnergetic
          ? "bg-brick-primary/10 text-brick-primary hover:bg-brick-primary/15 focus:ring-brick-primary"
          : "bg-yellow-100 text-yellow-800 hover:bg-yellow-200 focus:ring-yellow-500"
      }`}
      aria-label="Bekijk reden voor EPC vernieuwing"
    >
      <Warning size={14} weight="fill" />
      EPC te updaten
    </button>
  );
}
